import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'; 
import './styles.css';
import { useToken } from '../components/items/UseToken';
import ChatWindow from './ChatWindows';
import ChatImage from './chat.mov';
import Button from "@mui/material/Button";
import ChatWidget from './chatwidget';

export default function ChatApp() {
    
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const { token } = useToken();
    const notificationRef = useRef();

    

    // Fetch agents dynamically
    useEffect(() => {
        const fetchAgents = async () => {
            try {
                const response = await fetch('api/getdatabase?table_name=agents', {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                });
                const result = await response.json();
                setAgents(Array.isArray(result.results) ? result.results : []);
            } catch (error) {
                console.error("Failed to fetch agents:", error);
            }
        };

        fetchAgents();
    }, [token]);

    

    const selectAgent = (agent) => {
        setSelectedAgent(agent);
        
    };

    

    return (
        <div className="chat-container">
            {/* Left Pane - Agents List */}
            
            {agents.length > 0 ? (
                <div className="contacts-sidebar">
                    {agents.map((agent) => (
                        <div
                            key={agent.guid}
                            className={`contact ${selectedAgent?.guid === agent.guid ? 'selected' : ''}`}
                            onClick={() => selectAgent(agent)}
                        >
                            <img
                                src={
                                    agent.picture.startsWith("data:image")
                                        ? agent.picture
                                        : `data:image/png;base64,${agent.picture}`
                                }
                                alt={agent.name}
                                className="contact-avatar"
                            />
                            <div className="contact-info">
                                <h4 style={{ fontSize: "20px", fontWeight: 400 }}>{agent.name}</h4>
                                <p style={{ fontSize: "15px", fontWeight: 300 }}>
                                    {agent.title || "AI Assistant"}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : null}

            

            {/* Main Chat Area */}
            {selectedAgent ? (
                //<ChatWindow
                //    selectedAgent={selectedAgent}
                //    notificationRef={notificationRef}
                ///>
                <div className="flex flex-col overflow-hidden h-full w-full border border-gray-300 dark:border-gray-800 bg-white shadow-2xl rounded-md">
                    <ChatWidget chatAgent={selectedAgent} clientId={""} ></ChatWidget>
                </div>
            ) 
                :
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "90vh", // pełna wysokość ekranu
                        overflow: "hidden",
                        borderRadius: "6px",
                    }}
                >
                    {/* 🎥 Tło video */}
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "6px",
                            //filter: "brightness(1) blur(5px)", // lekko przyciemnione i rozmyte
                            zIndex: 0,
                        }}
                    >
                        <source src={ChatImage} type="video/mp4" />
                        <source src={ChatImage} type="video/quicktime" />
                        Your browser does not support the video tag.
                    </video>

                    {/* 🧩 Overlay content */}
                    <div
                        className="before-chat"
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            zIndex: 1,
                            color: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "16px",
                        }}
                    >
                        {agents.length > 0 ? (
                            <>
                                <h4 style={{ fontWeight: "400", color: "#000" }}>
                                    Select an agent on the left to start chatting
                                </h4>
                                <p style={{ fontWeight: "400", color: "#000" }}>or</p>
                            </>
                        ) : (
                            <>
                                    <h4 style={{ fontWeight: "400", color: "#000" }}>Create new agent to use this chat</h4>
                            </>
                        )}

                        <Button
                            component={Link}
                            to="/agents"
                            variant="contained"
                            sx={{
                                backgroundColor: "#7F56D9",
                                color: "#fff",
                                borderRadius: "9999px",
                                padding: "10px 32px",
                                fontSize: "1rem",
                                textTransform: "none",
                                fontWeight: 400,
                                boxShadow: "none",
                                "&:hover": {
                                    backgroundColor: "#6E46C4",
                                    boxShadow: "0 4px 10px rgba(127, 86, 217, 0.3)",
                                },
                            }}
                        >
                            Create New Agent
                        </Button>
                    </div>
                </div>

            }

            {/* Right Pane - Agent Details */}
            {/*{selectedAgent && (*/}
            {/*    <div className="profile-sidebar">*/}
            {/*        <img*/}
            {/*            src={selectedAgent.picture.startsWith("data:image") ? selectedAgent.picture : `data:image/png;base64,${selectedAgent.picture}`}*/}
            {/*            alt={selectedAgent.name}*/}
            {/*            className="profile-avatar"*/}
            {/*        />*/}
            {/*        <h4>{selectedAgent.name}</h4>*/}
            {/*        <p>{selectedAgent.title || "AI Assistant"}</p>*/}
            {/*        <div className="skill-description">*/}
            {/*            <h5 style={{ fontSize: "18px", fontWeight: "400" }}>Skill Description</h5>*/}
            {/*            <p style={{fontSize: "14px", fontWeight: "300", color: "#4b4b4b"}}>{selectedAgent.job_description || "No skills provided."}</p>*/}
            {/*        </div>*/}
            {/*        <div ref={notificationRef} id="notification" className="notification hidden"></div>*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    );
}
